import { render, staticRenderFns } from "./init.vue?vue&type=template&id=58453e18&scoped=true"
import script from "./init.vue?vue&type=script&lang=js"
export * from "./init.vue?vue&type=script&lang=js"
import style0 from "./init.vue?vue&type=style&index=0&id=58453e18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58453e18",
  null
  
)

export default component.exports